const gql = String.raw

/**
 * SEO Configuration used in post/pages
 */
export const SEO_CONFIG = gql`
  seo {
    title
    metaDesc
    opengraphUrl
    opengraphSiteName
    opengraphAuthor
    opengraphPublishedTime
    metaRobotsNoindex
    metaRobotsNofollow
    opengraphImage {
      sourceUrl
      mediaDetails {
        height
        width
      }
    }
    twitterImage {
      sourceUrl
    }
    opengraphDescription
    opengraphTitle
    opengraphPublisher
    opengraphModifiedTime
    twitterDescription
    twitterTitle
  }
`

/**
 * Get Wordpress YOAST SEO Configuration (GENERAL)
 * https://github.com/ashhitch/wp-graphql-yoast-seo
 */
export const WP_SEO_CONFIG_QUERY = gql`
  query GetSeoConfig {
    seo {
      social {
        twitter {
          cardType
        }
      }
    }
  }
`
